import { useEffect, useRef, useState } from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

interface ProtectedRouteProps {
  children: JSX.Element;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const token = Cookies.get("userToken");
  const firstLoadRef = useRef(true);
  const [reloading, setReloading] = useState(false);

  useEffect(() => {
    if (!firstLoadRef.current) return;

    const loaded = localStorage.getItem("permissionsLoaded");
    if (!loaded || loaded === "false") {
      // Set flag so it won't reload again
      localStorage.setItem("permissionsLoaded", "true");

      // Prevent multiple reloads in stateful environment
      setReloading(true);
      window.location.reload();
    }

    firstLoadRef.current = false;
  }, []);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // During reload, avoid rendering children
  if (reloading) return null;

  return children;
};

export default ProtectedRoute;
